export const paywallConstants = {
    SHOW_PAYWALL: 'SHOW_PAYWALL',
    HIDE_PAYWALL: 'HIDE_PAYWALL',
};